// @ts-strict-ignore
import React, { useContext } from 'react';
import { createWorkflowHistoryThunk, toggleGroupTypeInStateThunk } from 'flow/store/redux/thunks';
import { useAppDispatch } from '~/store/reduxHooks';
import { RuleBuilderContext } from '../../context';
import type { Option } from '@usealloy/component-library';
import type { GroupRule } from 'flow/service/rules';
import { groupTypeOptions } from './constants';
import { GroupContext } from '../Group/context';
import { getMultiSelectProps } from '../Threshold/helpers';
import RuleMultiSelect from './RuleMultiSelect';
import { isDisabled } from '../../helpers';
import { changeDescription } from 'flow/store/redux/types';
import type { WorkflowStateChange } from 'flow/store/redux/types';
import { createUiEffectContext } from 'flow/service/history';
import { isPreviewAction } from 'flow/service/actions';
import { UserContext } from '~/dashboard/context';
import { Operation } from 'flow/service/changelog/types';

interface GroupTypeSelectProps {
  rule: GroupRule;
}

export default function GroupTypeSelect({ rule }: GroupTypeSelectProps) {
  const dispatch = useAppDispatch();
  const {
    sourceAction,
    ruleTree,
    editMode,
    isTreeAmbiguous,
  } = useContext(RuleBuilderContext);

  const { hasAmbiguousRules } = useContext(GroupContext);
  const { featureFlags } = useContext(UserContext);

  const selectOption: Option = {
    label: rule.data.groupType,
    value: rule.data.groupType,
  };

  function handleDispatch(stateChange: WorkflowStateChange) {
    dispatch(
      createWorkflowHistoryThunk(
        stateChange,
        Boolean(featureFlags?.workflowEditorUndoRedo) && !isPreviewAction(sourceAction),
        {
          operation: Operation.Modify,
          uiEffectContext: createUiEffectContext(changeDescription.group, {
            actionId: sourceAction.publicId,
          }),
        },
      ),
    );
  }

  const onChange = option => {
    if (option.value !== rule.data.groupType) {
      handleDispatch(
        () => dispatch(toggleGroupTypeInStateThunk({
          action: sourceAction,
          treeRoot: ruleTree,
          rule,
        })),
      );
    }
  };

  const multiSelectProps = getMultiSelectProps({
    options: {
      isPreview: isDisabled(editMode),
    },
  });

  return (
    <RuleMultiSelect
      {...multiSelectProps}
      options={groupTypeOptions}
      onChange={onChange}
      selectedOptions={selectOption}
      isDisabled={isTreeAmbiguous}
      isInvalid={hasAmbiguousRules}
      isMulti={false}
      isNaked
    />
  );
}
